const get = key => {
  const re = new RegExp(`${key}=([^;]+)`)
  const value = re.exec(document.cookie) // eslint-disable-line
  return value != null ? unescape(value[1]) : null
}

const create = (key, value, expires) => {
  document.cookie = `${key}=${value};domain=.olx.com.br;path=/;expires=${expires};`
}

export default {
  get,
  create,
}
